/*
 * 功能名称: 月度工作日维护
 * 创 建 人: 张敬磊
 * 日    期: 2025年9月4日
 */
import { NewviewOaBaseApi } from './NewviewOaBaseApi'

export class WorkMonthdaysApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'work-monthdays'
  }
}